<template>
    <section id="about-us" class="what-we-do">
        <div data-aos="fade-up" data-aos-duration="1000" class="section-title">
            <h2>درباره رامنیک</h2>
            <p>رامنیک خدمات فروش اقساطی و فروش تخفیفی را ارائه میکند.</p>
        </div>
        <div class="col-12">
            <div class="col-lg-5 p-0 float-dynamic">
                <img src="../../assets/image/person-holding-white-nicard.jpg" />
            </div>
            <div data-aos="fade-up"
                 data-aos-duration="1000"
                 class="col-lg-7 desc float-dynamic">
                <p>
                    شرکت راه آرمان مهر نیکان (رامنیک) با تکیه بر تجارب بیش از ده ساله مدیران و مشاورین خود در حوزه تجارت الکترونیک، اقدام به تاسیس یک باشگاه لویالتی با نام «نیکارت» نموده است، که در حال حاضر این باشگاه در زمینه فروش اقساطی و فروش تخفیفی فعالیت می نماید.
                </p>
                <p>
                    نیکارت یک کارت خرید تعهدی و بدون پرداخت هرگونه کارمزد خرید، از سوی خریدار (دارنده نیکارت) به رامنیک می باشد و دارنده آن می تواند از تمامی مراکز عضو باشگاه نیکارت (فروشگاهی، خدماتی، درمانی، آموزشی، تفریحی و ...) بصورت اقساط و یا تخفیفی خرید نماید.
                </p>
            </div>
        </div>
    </section>
</template>
<script>
    export default {};
</script>
<style scoped>


    .what-we-do {
        background: #fff;
    }

        .what-we-do img {
            max-width: 100%;
        }

        .what-we-do .desc {
            margin-top: 50px;
            padding-top:50px;
            min-height: 340px;
            right: -70px;
            padding: 70px 50px;
            background: #f8f8f8;
            border: #ddd solid 1px;
        }

    @media (max-width: 1024px) {
        .what-we-do .desc {
            margin-top: 0px;
            right: unset;
            min-height:unset;
            height: auto;
            padding-top: 20px;
            padding-bottom:0px;
            padding-left:0;
            padding-right:0;
            background: unset;
            border: unset;
            text-align: justify;
        }
    }
</style>
